import { useCallback, useState } from 'react'
import { readInboxDenseLayout, writeInboxDenseLayout } from '@/lib/inbox-layout-preferences'

/** Inbox list density shared between main inbox page and sidebar panel. */
export function useInboxDenseLayout(defaultDense = false) {
  const [dense, setDenseState] = useState(() => readInboxDenseLayout(defaultDense))

  const setDense = useCallback((next: boolean) => {
    setDenseState(next)
    writeInboxDenseLayout(next)
  }, [])

  return { dense, setDense }
}
